import { useParams } from 'react-router'
import { useQuery } from '@apollo/client'
import { GOAL_GROUP_CARDS } from 'Apollo/Queries/GoalGroupCards'
import { useAppState } from 'Context/AppContext/AppContext'
import {
  Goal,
  GoalGroupCard as GoalGroupCardType,
} from 'Generated/graphql-types'
import { GOAL_SHARED_TO_FUNDER_CARD } from 'Apollo/Queries/GoalSharedToFunderCard'
import { SuperLoading } from 'Components/SharedComponents/Loading/SuperLoading'
import { FunderGoalGroup } from './FunderGoalGroup'
import { GoalSharedToFunder } from './GoalSharedToFunder'
import { FunderGoalPageContainer } from './FunderGoal.styled'
import { BackToLink } from '../../../../SharedComponents/BackToLink/BackToLink'

const FUNDER_GOALS_PATH = '/funder/impact/goals'

export const FunderGoal = () => {
  const slug = useParams<{
    goalGroupId?: string
    goalId?: string
  }>()
  const { goalId, goalGroupId } = slug
  const {
    funderOrgConfig: { orgId: funderOrgId },
  } = useAppState()

  const goalIdInt = goalId ? parseInt(goalId, 10) : null

  const {
    data: { goalSharedToFunderCard: goalData = [] } = {},
    loading: goalLoading,
  } = useQuery(GOAL_SHARED_TO_FUNDER_CARD, {
    variables: { activeOnly: true, funderOrgId, goalId: goalIdInt },
    skip: !goalIdInt,
  })

  const goalGroupIdInt = goalGroupId ? parseInt(goalGroupId, 10) : null

  const {
    data: { goalGroupCards: goalGroupData = [] } = {},
    loading: goalGroupsLoading,
  } = useQuery(GOAL_GROUP_CARDS, {
    variables: { funderOrgId, goalGroupId: goalGroupIdInt },
    skip: !goalGroupIdInt,
  })

  const loading = goalLoading || goalGroupsLoading
  if (loading || goalGroupsLoading) return <SuperLoading />

  const goalGroup: GoalGroupCardType = goalGroupData?.[0]

  const targetProgress = goalData?.[0] ? goalData?.[0].targetProgress : null

  const goal: Goal = goalData?.[0]

  return (
    <FunderGoalPageContainer>
      <BackToLink label='Back to Goals' path={FUNDER_GOALS_PATH} />
      {goalGroupIdInt ? (
        <FunderGoalGroup
          goalGroup={goalGroup}
          goalGroupTargetDescription={goalGroup.targetDescription}
        />
      ) : (
        <GoalSharedToFunder goal={goal} targetProgress={targetProgress} />
      )}
    </FunderGoalPageContainer>
  )
}
